import React from 'react';
import { Link } from 'react-router-dom';
import articleHero from '../assets/articlehero.png';
import { articles } from '../data/articles';

const Articles = () => {
  return (
    <div className="bg-white">
      <section
        className="relative isolate min-h-[38vh] w-full overflow-hidden sm:min-h-[40vh]"
        aria-labelledby="articles-hero-heading"
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${articleHero})` }}
          aria-hidden
        />
        <div
          className="pointer-events-none absolute inset-0 bg-gradient-to-b from-slate-950/55 via-slate-950/35 to-slate-950/60"
          aria-hidden
        />

        <div className="relative z-10 mx-auto flex min-h-[38vh] max-w-6xl flex-col items-center justify-center px-4 py-12 sm:min-h-[40vh] sm:px-6 sm:py-14 lg:px-8">
          <div className="w-full max-w-xl text-center">
            <h1
              id="articles-hero-heading"
              className="text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl"
            >
              Articles
            </h1>
            <p className="mt-4 text-pretty text-base leading-relaxed text-slate-100/95 sm:text-lg">
              Browse our latest medical reporting—clear context on evidence, benefits, and limits.
            </p>
          </div>
        </div>
      </section>

      <div className="mx-auto w-full max-w-[1680px] px-4 py-10 sm:px-6 lg:px-8 xl:px-10 2xl:px-12 lg:py-14">
        <ul className="grid list-none gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {articles.map((article) => (
            <li key={article.id}>
              <Link
                to={article.path}
                className="group block h-full rounded-2xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
              >
                <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm ring-1 ring-slate-200/60 transition-shadow hover:shadow-md group-hover:border-brand-200/80">
                  <div className="relative aspect-[4/3] shrink-0 overflow-hidden bg-slate-100">
                    <img
                      src={article.imageUrl}
                      alt=""
                      className="h-full w-full object-cover"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-4 sm:p-5">
                    <h2 className="text-[0.95rem] font-semibold leading-snug text-slate-900 sm:text-base xl:text-[1.05rem] group-hover:text-brand-800">
                      {article.title}
                    </h2>
                    <div className="mt-auto flex w-full flex-wrap items-end justify-between gap-x-2 gap-y-1 pt-4">
                      <span className="min-w-0 text-left text-sm text-slate-600 xl:text-[0.9375rem]">
                        By {article.author}
                      </span>
                      <time
                        dateTime={article.dateTime}
                        className="shrink-0 text-right text-sm text-slate-500 tabular-nums xl:text-[0.9375rem]"
                      >
                        {article.date}
                      </time>
                    </div>
                  </div>
                </article>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Articles;
